import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`ArtExamination/getProvince`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 列表
  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artOpportunityPointManage/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  insert({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artOpportunityPointManage/insert`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  update({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`artOpportunityPointManage/update`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  remove({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`artOpportunityPointManage/remove`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`artOpportunityPointManage/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
},
exportScheme({ commit }, params) {
  return new Promise((resolve, reject) => {
    axios.post(`/artOpportunityPointManage/exportScheme`, params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
},
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artOpportunityPointManage/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


  // exportData({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`artCheckAndImport/exportData`, params)
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },
  // exportData({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       method: 'post',
  //       url: '/customer/exportData',
  //       data: params,
  //       responseType: 'blob',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }).then(response => {
  //       resolve(response)
  //     }).catch((error) => {
  //       reject(error)
  //     })
  //   })
  // },

}
